import { confirmDialog } from '../stores';
export function showConfirm(title, message) {
    return new Promise((resolve, reject) => {
        confirmDialog.show(title, message, resolve, reject);
    });
}
